import { Link } from "react-router-dom";

export default function Books() {
  return (
    <div className="flex flex-col bg-[#FFF8F6] px-40 py-10 gap-20">
      <div
        className="relative flex flex-col bg-[#2A1613] rounded-3xl p-20 text-white items-center gap-8 overflow-hidden"
        data-aos="fade-up"
      >
        <div className="absolute -right-44 -top-44 w-1/3 h-80 rounded-full bg-[#B70100]/20 blur-3xl pointer-events-none" />
        <h1 className="font-bold text-4xl w-1/2 text-center">
          Ready to Start Your Indonesian Journey?
        </h1>
        <p className="w-3/5 text-center">
          Join a growing community of learners and learn Indonesian with expert
          tutors through a thoughtful, real-world approach.
        </p>
        <div className="flex gap-4">
          <Link
            to="/Trial/TrialClass"
            className="flex bg-[#B70100] px-6 py-2 text-white rounded-full cursor-pointer"
          >
            Book a Free Trial
          </Link>
          <Link
            to="/program-selection"
            className="flex bg-transparent border-2 border-[#FFF8F6] text-[#FFF8F6] rounded-full px-6 py-2 cursor-pointer hover:bg-[#FFF8F6] hover:text-[#2A1613]"
          >
            View Our Programs
          </Link>
        </div>
      </div>
    </div>
  );
}
